import app from 'flarum/forum/app';
import COUNTRIES from './countries';

/** Shared, cached look-ups for states, LGAs and country names. */
let statesPromise = null;
const lgaCache = {};
export function loadStates() {
  statesPromise ??= app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/voucha-community/states'
  }).then(r => r.states).catch(e => {
    statesPromise = null;
    throw e;
  });
  return statesPromise;
}
export function loadLgas(stateId) {
  if (!stateId) return Promise.resolve([]);
  lgaCache[stateId] ??= app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/voucha-community/states/' + stateId + '/lgas'
  }).then(r => r.lgas);
  return lgaCache[stateId];
}
export function countryName(code) {
  const hit = COUNTRIES.find(c => c[0] === code);
  return hit ? hit[1] : code;
}

/** A suggestion only (members always confirm): the device's time zone -> a likely country. */
export function suggestedCountry() {
  let tz = '';
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch (e) {}
  if (tz === 'Africa/Lagos') return 'NG';
  if (/^America\/(Toronto|Montreal|Vancouver|Edmonton|Winnipeg|Halifax|Regina|St_Johns|Moncton|Whitehorse|Yellowknife|Iqaluit)$/.test(tz)) return 'CA';
  if (tz === 'Europe/London') return 'GB';
  if (tz === 'Europe/Dublin') return 'IE';
  if (/^America\//.test(tz) || tz.startsWith('US/')) return 'US';
  return '';
}
flarum.reg.add('voucha-community', 'common/geo', { loadStates: loadStates,loadLgas: loadLgas,countryName: countryName,suggestedCountry: suggestedCountry, });